// extracted by mini-css-extract-plugin
export var videoContainer = "_jv-0";
export var videoIframe = "_jv-3";
export var videoLink = "_jv-1";
export var videoOverlay = "_jv-4";
export var videoOverlayText = "_jv-5";
export var videoWrapper = "_jv-2";